import {OrderProvider} from 'providers/OrderProvider'
import {useMemo} from 'react'
import {getOrderQuestions} from 'utils/getOrderQuestions'

export const useOrderQuestions = () => {
  const order = OrderProvider.useOrder()
  return useMemo(() => getOrderQuestions(order), [order])
}
